// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React from "react";
import Link from "redux-first-router-link";

import type { RoomId } from "src/types";
import * as atypes from "src/constants/actionTypes";
import { openConversationModal } from "src/actions/chatroom";

type Props = {
  seqNo: number,
  title: string,
  address: string,
  id: RoomId,
  templatedId: ?number,
  openConversationModal: Function
};

const Title = ({
  seqNo,
  title,
  address,
  id,
  templatedId,
  openConversationModal
}: Props) => {
  const handleConversation = () => {
    openConversationModal(id);
  };

  return (
    <Link
      onClick={handleConversation}
      to={{
        type: atypes.SET_CURRENT_CHATROOM_REQUEST,
        payload: {
          id: address
        },
        meta: {
          query: {
            templatedId
          }
        }
      }}
      title={title}
    >
      {seqNo && (
        <>
          {i18n.t(k._7)}
          {seqNo}
          {i18n.t(k._)}{" "}
        </>
      )}
      {title ? <>{title}</> : <i>{i18n.t(k.UNTITLED)}</i>}
    </Link>
  );
};

const mapDispatchToProps = {
  openConversationModal
};

export default connect(null, mapDispatchToProps)(Title);
